/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mTabThree.vue?vue&type=template&id=35a067a9"
import script from "./mTabThree.vue?vue&type=script&lang=js"
export * from "./mTabThree.vue?vue&type=script&lang=js"
import style0 from "./mTabThree.vue?vue&type=style&index=0&id=35a067a9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports